export const getNextGiftCardURL = (cardName, productLineId, configurationId) => {
  const url = `/gift-cards/p/${cardName?.split(' ').join('-')}/${productLineId}/${configurationId}`;
  return url;
};
